import "./Profile.css";
export default function Mobile() {
  return (
    <>
      <div className="det">
        <h1>Information</h1>
        <hr />
        <h2>Email: mailapurv@007gmail.com</h2>
        <br />
        <h2>Mobile: 9304945343</h2>
        <br />
        <h2>Location: Hajipur</h2>
        <br />
        <h2>Education: B.E</h2>
        <br />
      </div>
    </>
  );
}
